import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Inline, Pressable, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	statusWrapperStylesFullWidth: {
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.small'),
		paddingRight: token('space.050'),
		paddingLeft: token('space.050'),
		width: 'fit-content',
		height: '24px',
	},

	statusWrapper: {
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.small'),
		paddingRight: token('space.050'),
		paddingLeft: token('space.050'),
		width: '200px',
		height: '24px',
	},

	pressable: {
		borderRadius: token('radius.small'),
		padding: '0',
		backgroundColor: token('color.background.neutral.subtle'),
		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
		},
	},
	disabled: {
		opacity: token('opacity.disabled'),
	},
});

type InlineIconTextProps = {
	content: string;
	fullWidth?: boolean;
	icon?: React.ReactNode;
	isDisabledOpacity?: boolean;
	onClick?: () => void;
	testId?: string;
};

export const InlineIconText = ({
	icon,
	content,
	fullWidth,
	testId,
	onClick,
	isDisabledOpacity = false,
}: InlineIconTextProps): React.JSX.Element => {
	const renderContent = () => {
		return (
			<Inline
				space="space.050"
				alignBlock="center"
				xcss={cx(
					fullWidth ? styles.statusWrapperStylesFullWidth : styles.statusWrapper,
					isDisabledOpacity && styles.disabled,
				)}
				testId={testId}
			>
				{icon}
				<Text maxLines={1}>{content}</Text>
			</Inline>
		);
	};

	if (onClick) {
		return (
			<Pressable onClick={onClick} xcss={styles.pressable}>
				{renderContent()}
			</Pressable>
		);
	}

	return renderContent();
};
